import Loading from '@/assets/lottie/loading.json';
import OnboardingOverlay from '@/components/Onboarding';
import { useAuth } from '@/contexts/AuthContext';
import { useOnboarding } from '@/contexts/OnboardingContext';
import Lottie from 'lottie-react';

const LOADING_LOTTIE_STYLE = { width: 132, height: 100 };

const OnboardingPage = () => {
    const { workspaceMembers: { isLoadingInvitations }, isLoadingProfile } = useAuth();
    const { onboardingData } = useOnboarding();
    const currentStep = onboardingData.currentStep ?? 0;
    const isConnectFlowActive = Boolean(
        onboardingData.workspaceId ||
        onboardingData.pendingConnectionRequest ||
        onboardingData.storeConnectionPlatform ||
        currentStep > 0
    );
    const shouldShowInvitationLoading = isLoadingInvitations && !isConnectFlowActive;

    if (isLoadingProfile) {
        return (
            <div
                className="w-full h-screen bg-[#F8F9FB] flex items-center justify-center"
                style={{ zIndex: 9999 }}
            >
                <Lottie animationData={Loading} style={LOADING_LOTTIE_STYLE} />
            </div>
        );
    }

    return (
        <div className="w-full h-screen bg-[#F8F9FB] flex items-center justify-center">
            {shouldShowInvitationLoading ? (
                <div
                    style={{
                        zIndex: 9999,
                        position: 'absolute',
                        background: '#fff',
                        top: 0, left: 0, right: 0, bottom: 0, display: 'flex', justifyContent: 'center', alignItems: 'center'
                    }}
                >
                    <Lottie animationData={Loading} style={LOADING_LOTTIE_STYLE} />
                </div>
            ) : null}
            {/* 这个页面主要作为 OnboardingOverlay 的背景载体 */}
            <OnboardingOverlay />
        </div>
    );
};

export default OnboardingPage;
